import { render, staticRenderFns } from "./AboutPrivacy.vue?vue&type=template&id=1fe5eb5d&scoped=true&"
import script from "./AboutPrivacy.vue?vue&type=script&lang=js&"
export * from "./AboutPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./AboutPrivacy.vue?vue&type=style&index=0&id=1fe5eb5d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5eb5d",
  null
  
)

export default component.exports